// Utility functions for role addition and onboarding
import { RoleAddtionAction } from './Action';
import customToast, { showApiResponseToast } from '../../../utils/customToast';
export const buildRoleAdditionRequests = (
  selected_manufacturer_roles = [],
  { companyId = null, gst_details = {}, pan_details = {}, operational_details = {}, existingFirm = false } = {}
) => {
  return (selected_manufacturer_roles || []).map((role) => ({
    manufacturer_id: role.manufacturer_id,
    firm_role_id: role.firm_role_id || role.role_id,
    company_id: existingFirm ? companyId : null,
    gstin: gst_details?.gst_number || null,
    pancard_no: pan_details?.pan_number || operational_details?.pan_number || null,
    operational_address: {
      company_address: {
        address_line_1: operational_details?.address_line_1 || null,
        address_line_2: operational_details?.address_line_2 || null,
        address_line_3: operational_details?.address_line_3 || null,
      },
      state_id: operational_details?.state_id || null,
      district_id: operational_details?.district_id || null,
      location_id: operational_details?.location_id || null,
      taluka_id: operational_details?.taluka_id || null,
      pincode: operational_details?.pincode_id ? parseInt(operational_details.pincode_id, 10) : null,
    },
  }));
};

export const executeRoleAdditionRequests = async (roleAdditionRequests = []) => {
  let allSuccess = true;
  for (const request of roleAdditionRequests) {
    const { error, message, data } = await RoleAddtionAction(request);
    if (error) {
      allSuccess = false;
      customToast.error(message || 'Unable to add role');
    } else {
      if (data?.response_meta) {
        showApiResponseToast(data.response_meta, message);
      } else if (message) {
        customToast.success(message);
      }
    }
  }
  return { success: allSuccess };
};
